import { environment } from '../../environments/environment';

export const AUTH_RETURN_URL_STORAGE_KEY = 'amplify_auth_return_url';

const origin = globalThis.window?.location.origin ?? 'http://localhost:4200';

export const authConfig = {
  authority: environment.oidcAuthority,
  redirectUrl: `${origin}/callback`,
  postLogoutRedirectUri: `${origin}/landing`,
  clientId: 'amplify-client',
  scope: 'openid profile email',
  responseType: 'code',
  silentRenew: true,
  useRefreshToken: true,
  renewTimeBeforeTokenExpiresInSeconds: 30,
  ignoreNonceAfterRefresh: true,
};

export const PUBLIC_ROUTES = ['/', '/landing', '/callback'] as const;